import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { AllContactsContext } from "repository/stores/dashboard/contacts/contacts-all-provider";

// Actions
import { deletePaymentPlan } from "repository/actions/data/dashboard/payment-plans";

export default withSnackbar(
  withRouter(function (props) {
    const { isOpen, setClose, itemId, user } = props;
    // const [paymentPlans, setPaymentPlans] =
    //   React.useContext(AllContactsContext);
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeletePaymentPlan = () => {
      if (user && user != null) {
        setSaveLoading(true);

        deletePaymentPlan(itemId, user.idToken)
          .then((result) => {
            setClose();
            setSaveLoading(false);
            toast.success(`Payment plan successfully deleted`);
            window.location.reload();
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete selected payment plan"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeletePaymentPlan()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete this payment plan?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
